export const REWARD_INFO = "REWARD_INFO";
export const SOCIAL_IDS = "SOCIAL_IDS";
export const VALIDITY_DATA = "VALIDITY_DATA";